module.exports = __webpack_public_path__ + "img/Star_solid.b8b6ff20.svg";